<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      title="替换"
      :showFooter="false"
      width="420px"
      :innerHeight="200"
      :append-to-body="true"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
      v-el-drag-dialog
    >
      <!-- // 业务 -->
      <el-row type="flex">
        <el-form :model="formData" label-width="70px" size="small" style="flex: 1;">
          <el-form-item label="查找内容">
            <el-input v-model.trim="formData.keyword" placeholder="请输入查找内容" />
          </el-form-item>
          <el-form-item label="替换内容">
            <el-input v-model.trim="formData.instead" placeholder="请输入查找内容" />
          </el-form-item>
        </el-form>
        <div style="width: 100px;">
          <el-button type="" size="small" style="width: 100px;" @click="search">查找</el-button><br/>
          <el-button type="" size="small" style="width: 100px; margin-top: 5px;" @click="onReplace">替换</el-button><br/>
          <el-button type="primary" size="small" style="width: 100px; margin-top: 5px;" :disabled="!isShowSearchNext" @click="matchNext">查找下一处</el-button><br/>
          <el-button type="warning" size="small" style="width: 100px; margin-top: 5px;" @click="onReplaceAllRemote">全部替换</el-button><br/>
          <el-button type="primary" size="small" plain style="width: 100px; margin-top: 5px;" @click="onReplaceAll">全文替换</el-button>
        </div>
      </el-row>
      <!-- 全部替换 -->
      <replace-all 
        :visible.sync="replaceAllVisible" 
        :keyword="formData.keyword" 
        :instead="formData.instead" 
        @complete="handleReplaceAllComplete"
        v-if="replaceAllVisible"
      ></replace-all>
    </q-dialog>
  </div>
</template>

<script>
import elDragDialog from "@/directive/el-drag-dialog/index.js"; //01先引入这个指令

import replaceAll from './replaceAll'
export default {
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: ['visible','finalTableData', 'fileId', 'fileTypeCode',],
  directives: { elDragDialog },
  components: { replaceAll },
  data() {
    return {
      formData: {
        keyword: '',
        instead: ''
      },
      matchCell: [],
      activeIndex: 0,
      replaceAllVisible: false,
      textNum: [],
      selectIndex: 1,
      colorIndex: 1,
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
    // 是否显示“查找下一处”按钮
    isShowSearchNext() {
      if(this.matchCell.length >= 1) {
        return true
      }else{
        return false
      }
    },
    textLength() {
        this.textTypeNum = this.textNum[this.activeIndex].split(this.formData.keyword).length-2
        return this.textNum[this.activeIndex].split(this.formData.keyword).length-1
    },
  },
  mounted() {
    // String.prototype.betterReplace = function(search, replace, from) { 
 
    //       if (this.length > from) { 
      
    //       return this.slice(0, from) + this.slice(from).replace(search, replace); 
      
    //       } 
      
    //       return this; 
      
    //   } 
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      if (this.isNeedRefresh) {
        this.$emit('success');
      }
      this.$emit('close');
    },
    confirm() {
      this.updateVal();
    },
    search() {
      this.activeIndex = 0
      this.colorIndex = 1
      // 去掉不参与匹配的第一二列表头
      const finalTableData = JSON.parse(JSON.stringify(this.finalTableData));
      let tableContent = finalTableData.map(v=>{
        delete v.spanName;
        delete v.name;
        return {
          ...v
        }
      })
      console.log(tableContent);

      // 匹配到关键字的单元格集合，row：位于第几行，prop：位于哪一列
      let matchCell = [];
      tableContent.forEach((item, index)=>{
        // { field: "", prop[i]: "", prop[i+1]: "", ... , prop[i+n]: "", prop[i]_dataId: "" }
        // 参与匹配的字段只有prop[i];
        Object.keys(item).forEach(key=>{
          // console.log(key);
          if(key !== 'field' && !key.includes('_dataId') && item[key] && item[key].includes(this.formData.keyword)) {
            console.log(item);
            matchCell.push({
              row: index,
              prop: key
            })
            this.textNum.push(item.prop0)
            console.log(matchCell);
          }
        })
      })

      // 去掉不参与匹配的图片行
      let imgRow = tableContent.findIndex(v=>v.field == 'image');
      matchCell = matchCell.filter(v=>v.row !== imgRow);
      console.log(matchCell);
      this.matchCell = matchCell;
      this.textNum = this.textNum.filter(v=>!v.includes('png')).filter(v=>!v.includes('jpg')).filter(v=>!v.includes('jpeg')).filter(v=>!v.includes('bpm')).filter(v=>!v.includes('bmp'))
      this.matchOne();
      console.log(this.textNum);
      // let matchArr = [];
      // tableContent.formData((item, index) => {
      //   let rowArr = {};
      //   Object.keys(item).forEach(key=>{
      //     if(key !== 'field' && !key.includes('_dataId') && item[key] && item[key].includes(this.formData.keyword)) {
      //       rowArr[key] = item[key]
      //     }
      //   })
      // })
    },
    // 在table上高亮一个
    matchOne() {
      this.$emit('matched', this.matchCell[this.activeIndex],this.textNum[this.activeIndex],this.colorIndex)
    },
    // 查找下一处
    matchNext() {
      if(this.textLength == 0 || this.textTypeNum == 0) {
        this.activeIndex++;
        this.selectIndex = 1
        this.colorIndex = 0;
      }else {
        this.textTypeNum-=1
        this.selectIndex++
      }
      // 查找完毕后，自动循环。
      if(this.activeIndex == this.matchCell.length) {
        this.activeIndex = 0;
      }
      var valLength = this.textNum[this.activeIndex].match(new RegExp(this.formData.keyword+"", 'g')).length
      if (valLength > this.colorIndex) {
          this.colorIndex++;
      } else {
          this.colorIndex = 0;
      }
      this.$emit('matched', this.matchCell[this.activeIndex],this.textNum[this.activeIndex],this.colorIndex)
      },
       find(str,cha,num){
        var x=str.indexOf(cha);
        for(var i=0;i<num;i++){
          x=str.indexOf(cha,x+1);
        }
        return x;
      },
      changeStr(str,index,changeStr){
      return str.substr(0, index) + changeStr+ str.substr(index+ this.formData.keyword.length);
      },
    // 替换
    onReplace() {
      
      if(!this.formData.keyword || !this.formData.instead) {
        this.$message.error('请输入需要查找的关键词和需要替换的文本');
        return;
      }
      let {row, prop} = this.matchCell[this.activeIndex];
      let tagRow = this.finalTableData[row];
      // 当前单元格的值所对应原始数据里的dataId
      let dataId = tagRow[`${prop}_dataId`]
      // console.log(this.modifyAfterFunc(this.formData.instead, this.formData.keyword, tagRow[prop]));
      let data = {
        fileId: this.fileId,
        baseDataId: dataId,
        modifyAfter: this.modifyAfterFunc(this.formData.instead, this.formData.keyword, tagRow[prop]),
        modifyBefore: tagRow[prop],
        modifyField: tagRow.field,
        modifyFieldDesc: tagRow.name,
        businessType: this.fileTypeCode
      }
      console.log(data);
      this.$q.newProduct.editInformation({data})
      .then(res=>{
        if(res.code == 200) {
          this.$message.success('修改成功');
          this.colorIndex = 1;
          // this.activeIndex = 0
          // console.log(this.activeIndex);
          this.$emit('matched', this.matchCell[this.activeIndex],this.textNum[this.activeIndex],this.colorIndex)
        }else{
          this.$message.error(res.message)
        }
      })
      // 初始化修改记录
      .then(_=>{
        this.$emit('complete', null)
      })
    },
    // 把需要修改的关键词替换成新的值
    modifyAfterFunc(instead, keys, oldVal) {
      // const str = keys.replace(/([*.?+$^(){}|\\/])/g, '\\$1')
      // const reg = new RegExp(str, "g");
      // return oldVal.replace(reg, instead)
      // console.log(this.colorIndex-1);
      // if(oldVal.split(keys).length - 1 == 1){
      //   this.activeIndex = 0
      // }
      console.log(this.colorIndex);
      
      let index = JSON.parse(JSON.stringify(this.colorIndex))
      let valIndex=this.find(oldVal,keys,index-1)
      console.log(valIndex);
      let  value=this.changeStr(oldVal,valIndex,instead)
      console.log(value);
      // console.log(index>=3?1:index);
      return value
      
    },
    modifyAfterFuncAll(instead, keys, oldVal) {
      const str = keys.replace(/([*.?+$^(){}|\\/])/g, '\\$1')
      const reg = new RegExp(str, "g");
      return oldVal.replace(reg, instead)
      
    },
    // 全文替换
    onReplaceAll() {
      if(!this.formData.keyword || !this.formData.instead) {
        this.$message.error('请输入需要查找的关键词和需要替换的文本');
        return;
      }
      this.search();
      if(!this.matchCell.length) {
        this.$message.error('无相关查找内容');
        return;
      }
      let requestParam = {
        excuseType: this.fileTypeCode,
        fileId: this.fileId,
        fieldList: []
      }
      this.matchCell.forEach((item, index)=>{
        let {row, prop} = item;
        let tagRow = this.finalTableData[row];
        // 当前单元格的值所对应原始数据里的dataId
        let dataId = tagRow[`${prop}_dataId`]
        let data = {
          dataId: dataId,
          modifyAfter: this.modifyAfterFuncAll(this.formData.instead, this.formData.keyword, tagRow[prop]),
          modifyBefore: tagRow[prop],
          modifyField: tagRow.field,
          modifyFieldDesc: tagRow.name
        }
        // 过滤掉图片列
        tagRow.field !== 'image' && requestParam.fieldList.push(data);
      })
      this.$q.newProduct.replaceExcuseData({data: requestParam})
      .then(res=>{
        if(res.code == 200) {
          // this.$message.success('修改成功')
          this.$alert(`本次替换共${requestParam.fieldList.length}处，已成功替换`, '全文替换', {
            confirmButtonText: '确定'
          });
        }else{
          this.$message.error(res.message)
        }
      })
      // 初始化修改记录
      .then(_=>{
        this.$emit('complete', null)
        this.updateVal();
      })
    },
    // 全文替换
    onReplaceAllRemote() {
      if(!this.formData.keyword || !this.formData.instead) {
        this.$message.error('请输入需要查找的关键词和需要替换的文本');
        return;
      }
      if(this.formData.keyword && this.formData.instead) {
        this.replaceAllVisible = true;
      }else{
        this.$message.error('请先填写替换的文本信息')
      }
    },
    // 全部替换回调
    handleReplaceAllComplete() {
      this.$emit('complete', null);
    }
  }
}
</script>

<style lang="stylus" scoped>
</style>